import { render, staticRenderFns } from "./ExpertIndex.vue?vue&type=template&id=4ce98bd0&scoped=true"
import script from "./ExpertIndex.vue?vue&type=script&lang=js"
export * from "./ExpertIndex.vue?vue&type=script&lang=js"
import style0 from "./ExpertIndex.vue?vue&type=style&index=0&id=4ce98bd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce98bd0",
  null
  
)

export default component.exports